import angular from 'angular';
import { LabelFieldComponent } from './label-field.component';

angular.module('core.components.label-field', []).component('esLabelField', LabelFieldComponent);
